<template>
  <footer class="footer"></footer>
</template>

<style scoped>
.footer {
  margin-top: 1rem;
  min-height: 3rem;
}
</style>
